import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const HelpChatList = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("ask");

  const chats = [
    { id: 1, name: "Balasundar", message: "Hi, Balasundar Thank you for contacting...", time: "2 hrs ago" },
    { id: 2, name: "Balasundar", message: "Hi, Balasundar Thank you for contacting...", time: "5 days ago" },
    { id: 3, name: "Balasundar", message: "Hi, Balasundar Thank you for contacting...", time: "5 days ago" },
  ];

  const faqs = [
    { id: 1, question: "How to track my order?", answer: "Go to Orders > Track Order." },
    { id: 2, question: "How can I contact support?", answer: "You can start a chat from the Ask tab." },
    { id: 3, question: "How to reset my password?", answer: "Click on Forgot Password on the login page." },
  ];

  return (
    <div className="min-h-screen bg-white px-4 py-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <button className="text-lg font-medium text-gray-700" onClick={() => navigate(-1)}>&larr;</button>
        <h1 className="text-lg font-bold">Help Chat</h1>
        <div className="w-6" />
      </div>

      {/* Tabs */}
      <div className="flex border border-red-600 rounded-full w-fit mb-4 mx-auto overflow-hidden">
        <button
          className={`px-6 py-1 text-sm font-medium ${
            activeTab === "ask" ? "text-white bg-primary" : "text-primary bg-white"
          }`}
          onClick={() => setActiveTab("ask")}
        >
          Ask
        </button>
        <button
          className={`px-6 py-1 text-sm font-medium ${
            activeTab === "faq" ? "text-white bg-primary" : "text-primary bg-white"
          }`}
          onClick={() => setActiveTab("faq")}
        >
          FAQs
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "ask" ? (
        <>
          {/* Chat List */}
          <div className="space-y-4">
            {chats.map((chat) => (
              <div
                key={chat.id}
                onClick={() => navigate(`/chat/${chat.id}`)}
                className="flex items-center gap-3 bg-white shadow rounded-xl p-3 cursor-pointer hover:bg-gray-50"
              >
                <img
                  src={`https://i.pravatar.cc/40?img=${chat.id}`}
                  alt="avatar"
                  className="w-10 h-10 rounded-full"
                />
                <div className="flex-1">
                  <p className="font-semibold text-sm">{chat.name}</p>
                  <p className="text-xs text-gray-500">{chat.message}</p>
                </div>
                <p className="text-xs text-gray-400 whitespace-nowrap">{chat.time}</p>
              </div>
            ))}
          </div>

          {/* Button */}
          <div className="flex justify-center mt-8">
            <button
              className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-full shadow text-sm"
              onClick={() => navigate("/new-chat")}
            >
              <FaPlus />
              New Conversation
            </button>
          </div>
        </>
      ) : (
        <>
          {/* FAQ List */}
          <div className="space-y-4 mt-4">
            {faqs.map((faq) => (
              <div key={faq.id} className="bg-gray-100 p-4 rounded-lg shadow-sm">
                <p className="font-semibold text-sm mb-1">{faq.question}</p>
                <p className="text-xs text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HelpChatList;
